import React, { useState, useEffect } from "react";
import {useParams} from "react-router-dom";
import { getNativeByChain } from "helpers/networks";
import { getCollectionsByChain } from "helpers/collections";
import {
  useMoralis,
  useMoralisQuery,
  useNewMoralisObject,
} from "react-moralis";
import { Card, Image, Tooltip, Modal, Badge, Alert, Spin, Button, Select } from "antd";
import { useNFTTokenIds } from "hooks/useNFTTokenIds";
import { useNFTTokenIdMetadata } from "hooks/useNFTTokenIdMetadata";
import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";
import { getExplorer } from "helpers/networks";
import { useWeb3ExecuteFunction } from "react-moralis";

import Particles from "react-tsparticles";


import item_lg from '../img/item-lg.jpg';
import author_1 from '../img/authors/author-1.png';
import author_2 from '../img/authors/author-2.png';
import author_3 from '../img/authors/author-3.png';
import author_4 from '../img/authors/author-4.png';
import author_5 from '../img/authors/author-5.png';

const particlesInit = (main) => {
  console.log(main);

  // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
};

const particlesLoaded = (container) => {
  console.log(container);
};

function SingleItem({nft, viewType}) {
  const fallbackImg =
    "data:image/png;base64,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";
  
  const [price, setPrice] = useState(1);
  const [buttonType, setButtonType] = useState(viewType);
  const [loading, setLoading] = useState(false);
  const [tokenDetails, setTokenDetails] = useState(null);
  const { chainId, marketAddress, contractABI, walletAddress, erc20ContractABI, erc20Address } =
    useMoralisDapp();
  const contractABIJson = JSON.parse(contractABI);
  const { Moralis } = useMoralis();
  const contractProcessor = useWeb3ExecuteFunction();
  const queryMarketItems = useMoralisQuery("EvNewOffer");
  const purchaseItemFunction = "accept";
  const listItemFunction = "offer";

  const fetchMarketItems = JSON.parse(
    JSON.stringify(queryMarketItems.data, [
      "objectId",
      "createdAt",
      "user",
      "nft",
      "tokenId",
      "price",
      "side",
      "uid",
      "confirmed",
    ])
  );

  async function purchase() {
    setLoading(true);
    const _tokenDetails = getMarketItem(nft);
    
    if (_tokenDetails) {
      const _offerID = _tokenDetails.uid;
      const ops = {
        contractAddress: marketAddress,
        functionName: purchaseItemFunction,
        abi: contractABIJson,
        params: {
          id: _offerID,
        },
      };
    
      await contractProcessor.fetch({

        params: ops,
        onSuccess: () => {
          console.log("success");
          setLoading(false);
          updateSoldMarketItem();
          succPurchase();
        },
        onError: (error) => {
          setLoading(false);
          failPurchase();
        },
      });
    }
  }

  async function approveERC20() {
    setLoading(true);
    const _tokenDetails = getMarketItem(nft);
    setTokenDetails(_tokenDetails);
    const ops = {
      contractAddress: erc20Address,
      functionName: "approve",
      abi: [{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}],
      params: {
        spender: marketAddress,
        amount: String(_tokenDetails.price)
      },
    };

    await contractProcessor.fetch({
      params: ops,
      onSuccess: () => {
        console.log("Approval Received");
        setLoading(false);
        setButtonType(3);
        succErc20Approve();
      },
      onError: (error) => {
        console.log("Approval Failed");
        setLoading(false);
        failErc20Approve();
      },
    });
  }

  async function updateSoldMarketItem() {
    const id = getMarketItem(nft).objectId;
    const marketList = Moralis.Object.extend("EvNewOffer");
    const query = new Moralis.Query(marketList);
    await query.get(id).then((obj) => {
      obj.set("side", 2);
      obj.set("user", walletAddress);
      obj.save();
    });
  }

  async function list(nft, listPrice) {
    setLoading(true);
    const p = listPrice * ("1e" + 9);
    const ops = {
      contractAddress: marketAddress,
      functionName: listItemFunction,
      abi: contractABIJson,
      params: {
      side: 1, // SIDE_SELL
      nft: nft.token_address,
      tokenId: nft.token_id,
      price: String(p),
      },
    };
    await contractProcessor.fetch({
      params: ops,
      onSuccess: () => {
        console.log("success");
        setLoading(false);
        // addItemImage();
        succList();
      },
      onError: (error) => {
        setLoading(false);
        failList();
      },
    });
  }

  async function approveAll(nft) {
    console.log(nft);
    setLoading(true);  
    const ops = {
      contractAddress: nft.token_address,
      functionName: "setApprovalForAll",
      abi: [{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"}],
        params: {
        operator: marketAddress,
        approved: true
      },
    };

    await contractProcessor.fetch({
      params: ops,
      onSuccess: () => {
        console.log("Approval Received");
        setLoading(false);
        setButtonType(1);
        succApprove();
      },
      onError: (error) => {
        setLoading(false);
        failApprove();
      },
    });
  }

  function succErc20Approve() {
    let secondsToGo = 5;
    const modal = Modal.success({
      title: "Success!",
      content: `Approval is now set, you can buy the NFT`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function failErc20Approve() {
    let secondsToGo = 5;
    const modal = Modal.error({
      title: "Error!",
      content: `There was a problem with setting approval`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function succPurchase() {
    let secondsToGo = 5;
    const modal = Modal.success({
      title: "Success!",
      content: `You have purchased this NFT`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function failPurchase() {
    let secondsToGo = 5;
    const modal = Modal.error({
      title: "Error!",
      content: `There was a problem when purchasing this NFT`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function succList() {
    let secondsToGo = 5;
    const modal = Modal.success({
      title: "Success!",
      content: `Your NFT was listed on the marketplace`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function succApprove() {
    let secondsToGo = 5;
    const modal = Modal.success({
      title: "Success!",
      content: `Approval is now set, you may list your NFT`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function failList() {
    let secondsToGo = 5;
    const modal = Modal.error({
      title: "Error!",
      content: `There was a problem listing your NFT`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function failApprove() {
    let secondsToGo = 5;
    const modal = Modal.error({
      title: "Error!",
      content: `There was a problem with setting approval`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  const getMarketItem = (nft) => {
    const result = fetchMarketItems?.find(
      (e) =>
        e.nft.toLowerCase() === nft?.token_address.toLowerCase() &&
        e.tokenId === nft?.token_id &&
        e.side === 1 &&
        e.confirmed === true
    );
    return result;
  };

  return (
    <div>
      <section className="py-5 item-bg position-relative">
        <Particles id="particles-js" url="http://foo.bar/particles.json" init={particlesInit} loaded={particlesLoaded} />
        
          <div className="container py-5 mt-5 z-index-20">
            <h1 className="text-center text-white">Item Details</h1>
            
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center">
                <li className="breadcrumb-item">
                  <a className="text-decoration-none d-flex align-items-center" href="#"> <i className="las la-home la-sm me-1"></i>Home</a>
                </li>
                  <li className="breadcrumb-item active" aria-current="page">Item Details</li>
              </ol>
            </nav>
        </div>
      </section>



      
      <section className="py-5">
        <div className="container py-5">
          <div className="row mb-4 gy-4">

          
            <div className="col-lg-6">
              <div className="card shadow">
                <div className="card-body">
                <div className="row">
                {
                  (() => {
                    if (nft.fileType === 'video') {
                      return (
                        <video width="100%" height="100%" controls>
                          <source src={nft.image} type={nft.file} />
                        </video>
                      )
                    } else if (nft.fileType === 'image') {
                      return (
                        <img className="img-fluid col-12" src={nft.image} alt=""  />
                      )
                    } else if (nft.fileType === 'audio') {
                      return (
                        <audio controls>
                          <source src={nft.image} type={nft.file} />
                        </audio>
                      )
                    }
                  })()
                }
                </div>
                </div>
              </div>
            </div>

             
            <div className="col-lg-6">
              {
                getMarketItem(nft) ? ( <p className="mb-2 text-muted">Current price<span className="fw-bold ms-3 badge bg-primary">{getMarketItem(nft).price / (1e9)} SafeMars</span></p> ) :
                (<p className="mb-2 text-muted">&nbsp;</p>)
              }
              {
                nft && (<h1 className="singleItemHeader">{nft.name}</h1>)
              }
              <p className="text-muted mb-4">
                  {nft.description}
              </p>

               
              <div className="row mb-4" style={{display: 'none'}}>
                <div className="col-xl-8">
                  <div className="card shadow-sm rounded">
                    <div className="card-body p-4">
                      <ul className="list-unstyled text-sm text-muted mb-0">
                        <li className="d-flex align-items-center justify-content-between mb-2 pb-1">
                          <p className="mb-0 d-flex align-items-center"><i className="text-primary las la-user-circle"></i><span className="ms-2">Item Artist</span></p>
                          <p className="mb-0 text-gray-muted">Monica Lucas</p>
                        </li>
                        <li className="d-flex align-items-center justify-content-between mb-2 pb-1">
                          <p className="mb-0 d-flex align-items-center"><i className="text-primary las la-clock"></i><span className="ms-2">Created</span></p>
                          <p className="mb-0 text-gray-muted">22 Jun 2021</p>
                        </li>
                        <li className="d-flex align-items-center justify-content-between mb-2 pb-1">
                          <p className="mb-0 d-flex align-items-center"><i className="text-primary las la-crop-alt"></i><span className="ms-2">Item Size</span></p>
                          <p className="mb-0 text-gray-muted">2200 x 2500</p>
                        </li>
                        <li className="d-flex align-items-center justify-content-between mb-2 pb-1">
                          <p className="mb-0 d-flex align-items-center"><i className="text-primary las la-photo-video"></i><span className="ms-2">Formats</span></p>
                          <p className="mb-0 text-gray-muted">MP4, JPEG</p>
                        </li>
                        <li className="d-flex align-items-center justify-content-between mb-0">
                          <p className="mb-0 d-flex align-items-center"><i className="text-primary las la-save"></i><span className="ms-2">Downloadable file</span></p>
                          <p className="mb-0 text-gray-muted">Yes</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

               
              <div className="row">
                <div className="col-xl-8">
                  { (() => {
                      if (buttonType === 0) {
                        return (<h2 className="h5 mb-2 text-white">Approve NFT</h2>);
                      } else if (buttonType === 1) {
                        return (<h2 className="h5 mb-2 text-white">List</h2>);
                      } else if (buttonType === 2) {
                        return (<h2 className="h5 mb-2 text-white">Allow SafeMars</h2>);
                      } else if (buttonType === 3) {
                        return (<h2 className="h5 mb-2 text-white">Buy</h2>)
                      } else {
                        return (<h2 className="h5 mb-2 text-white">&nbsp;</h2>)
                      }
                    })()
                  }
                  {
                    (() => {
                      if (buttonType === 0) {
                        return (<p className="text-muted text-sm mb-4">Approve your NFT to sell on the marketplace for SafeMars</p>);
                      } else if (buttonType === 1) {
                        return (<p className="text-muted text-sm mb-4">Sell your NFT on the marketplace for SafeMars tokens</p>);
                      } else if (buttonType === 2) {
                        return (<p className="text-muted text-sm mb-4">Allow SafeMars tokens to buy the NFT</p>);
                      } else if (buttonType === 3) {
                        return (<p className="text-muted text-sm mb-4">Buy the NFT with SafeMars tokens</p>)
                      } else {
                        return (<p className="text-muted text-sm mb-4">&nbsp;</p>)
                      }
                    })()
                  }
                  <div className="mb-5">
                    {(() => {
                      if (buttonType === 0) {
                        if (!loading) {
                          return (
                            <button className="btn btn-primary btn-sm rounded-sm single_buy_button" onClick={() => approveAll(nft)}><i className="fas fa-paper-plan"></i>Approve</button>
                          );
                        } else {
                          return (
                            <button className="btn btn-primary btn-sm rounded-sm single_buy_button"><i className="fas fa-paper-plan"></i><Spin /></button>
                          );
                        }
                      } else if (buttonType === 1) {
                        if (!loading) {
                          return (
                            <div className="input-group p-1 shadow-sm rounded bg-dark founded">
                              <input className="form-control border-0 shadow-0 bg-dark" type="number" name="email" autocomplete="off" placeholder="SAFEMARS" value={price} onChange={(e) => setPrice(e.target.value)} />
                              <button className="btn btn-primary btn-sm rounded-sm single_buy_button" onClick={() => list(nft, price)}><i className="fas fa-paper-plan"></i>List</button>
                            </div>
                          );
                        } else {
                          return (
                            <div className="input-group p-1 shadow-sm rounded bg-dark founded">
                              <input className="form-control border-0 shadow-0 bg-dark" type="number" name="email" autocomplete="off" placeholder="SAFEMARS"/>
                              <button className="btn btn-primary btn-sm rounded-sm single_buy_button"><i className="fas fa-paper-plan"></i><Spin /></button>
                            </div>
                          );
                        }
                      } else if (buttonType === 2) {
                        if (!loading) {
                          return (
                            <button className="btn btn-primary btn-sm rounded-sm single_buy_button" onClick={approveERC20}><i className="fas fa-paper-plan"></i>Allow</button>
                          );
                        } else {
                          return (
                            <button className="btn btn-primary btn-sm rounded-sm single_buy_button"><i className="fas fa-paper-plan"></i><Spin /></button>
                          );
                        }
                      } else if (buttonType === 3) {
                        if (!loading) {
                          return (
                            <button className="btn btn-primary btn-sm rounded-sm single_buy_button" onClick={purchase}><i className="fas fa-paper-plan"></i>Buy</button>
                          );
                        } else {
                          return (
                            <button className="btn btn-primary btn-sm rounded-sm single_buy_button"><i className="fas fa-paper-plan"></i><Spin /></button>
                          );
                        }
                      } else {
                        return (<></>);
                      }
                    })()}
                  </div>
                </div>
              </div>

            </div>
          </div>

            <div className="row gy-4" style={{display: 'none'}}>
              
              <div className="col-12">
                <ul className="list-inline d-flex align-items-center">
                  <li className="list-inline-item me-2">
                    <a href="#!"> 
                    <img className="img-fluid rounded-circle p-1 bg-dark" src={author_1} alt="..." width="50" /></a>
                  </li>
                  <li className="list-inline-item me-3">
                    <a className="text-reset" href="#!"> <h6 className="mb-0">Monica Lucas</h6></a>
                  </li>
                  <li className="list-inline-item d-flex align-items-center">
                    <div className="icon bg-primary me-2"><i className="las la-check-double text-white fw-bold"></i></div>
                    <span className="text-muted text-sm">Verified user</span>
                  </li>
                </ul>
              </div>

               
                <div className="col-lg-6">
                    
                  <div className="bg-dark rounded shadow-sm p-1">
                    <ul className="nav nav-pills flex-column flex-sm-row mb-0" id="item-tab" role="tablist">
                      <li className="nav-item flex-sm-fill" role="presentation">
                        <button className="nav-link w-100 active" id="item-bids-tab" data-bs-toggle="pill" data-bs-target="#item-bids" type="button" role="tab" aria-controls="item-bids" aria-selected="true">Bids</button>
                      </li>
                      <li className="nav-item flex-sm-fill" role="presentation">
                        <button className="nav-link w-100" id="item-description-tab" data-bs-toggle="pill" data-bs-target="#item-description" type="button" role="tab" aria-controls="item-description" aria-selected="false">
                            Description
                        </button>
                      </li>
                      <li className="nav-item flex-sm-fill" role="presentation">
                        <button className="nav-link w-100" id="item-history-tab" data-bs-toggle="pill" data-bs-target="#item-history" type="button" role="tab" aria-controls="item-history" aria-selected="false">History</button>
                      </li>
                    </ul>
                  </div>

                 
                  <div className="tab-content py-3" id="item-tabContent">
                  
                    <div className="tab-pane fade show active" id="item-bids" role="tabpanel" aria-labelledby="item-bids-tab">
                      <ul className="list-unstyled">
                        
                        <li className="d-flex align-items-center rounded p-3 bd-3 bg-dark mb-2 card-hover-minimal">
                          <img className="img-fluid rounded-circle" src={author_2} alt="..." width="50" />
                          <div className="ms-2">
                            <p className="text-sm mb-1 text-muted">Bid accepted <span className="text-primary">0.005 BNB</span></p>
                            <p className="text-sm mb-0 text-muted">by <span className="text-primary">Monica Lucas </span>at 6/15/2021, 3:20 AM</p>
                          </div>
                        </li>
                    
                        <li className="d-flex align-items-center rounded p-3 bd-3 bg-dark mb-2 card-hover-minimal">
                          <img className="img-fluid rounded-circle" src={author_3} alt="..." width="50" />
                          <div className="ms-2">
                            <p className="text-sm mb-1 text-muted">Bid <span className="text-primary">0.005 BNB</span></p>
                            <p className="text-sm mb-0 text-muted">by <span className="text-primary">Mamie Barnett </span>at 6/15/2021, 3:20 AM</p>
                          </div>
                        </li>
                        
                        <li className="d-flex align-items-center rounded p-3 bd-3 bg-dark mb-2 card-hover-minimal">
                          <img className="img-fluid rounded-circle" src={author_4} alt="..." width="50" />
                          <div className="ms-2">
                            <p className="text-sm mb-1 text-muted">Bid <span className="text-primary">0.005 BNB</span></p>
                            <p className="text-sm mb-0 text-muted">by <span className="text-primary">Nicholas Daniels </span>at 6/15/2021, 3:20 AM</p>
                          </div>
                        </li>
                        
                        <li className="d-flex align-items-center rounded p-3 bd-3 bg-dark mb-2 card-hover-minimal">
                          <img className="img-fluid rounded-circle" src={author_5} alt="..." width="50" />
                          <div className="ms-2">
                            <p className="text-sm mb-1 text-muted">Bid <span className="text-primary">0.005 BNB</span></p>
                            <p className="text-sm mb-0 text-muted">by <span className="text-primary">Lori Hart </span>at 6/15/2021, 3:20 AM</p>
                          </div>
                        </li>
                      </ul>
                    </div>

                     
                    <div className="tab-pane fade" id="item-description" role="tabpanel" aria-labelledby="item-description-tab">
                      <h6>Description:</h6>
                      <p className="text-muted text-sm">
                          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolorem illum, sapiente dolor voluptatum deleniti sunt in natus aliquam libero. Totam, officiis porro? Quos dolor molestiae enim! Ipsa quaerat
                          temporibus totam!
                      </p>
                      <p className="text-muted text-sm">
                          Fugit praesentium inventore earum excepturi minima laborum laudantium dolores vitae placeat!Nesciunt qui amet fuga beatae sequi ipsum eaque minus itaque id deserunt eum maxime perspiciatis reiciendis
                          accusantium, aliquam illum deleniti. Minus ducimus eveniet repellendus, velit dolor est odit possimus! Modi.
                      </p>
                    </div>

                     
                  <div className="tab-pane fade" id="item-history" role="tabpanel" aria-labelledby="item-history-tab">

                      
                    <li className="d-flex align-items-center rounded p-3 bd-3 bg-dark mb-2 card-hover-minimal">
                      <img className="img-fluid rounded-circle" src="img/authors/author-2.png" alt="..." width="50" />
                      <div className="ms-2">
                        <p className="text-sm mb-1 text-muted">Bid <span className="text-primary">0.005 BNB</span></p>
                        <p className="text-sm mb-0 text-muted">by <span className="text-primary">Monica Lucas </span>at 6/15/2021, 3:20 AM</p>
                      </div>
                    </li>

                    
                    <li className="d-flex align-items-center rounded p-3 bd-3 bg-dark mb-2 card-hover-minimal">
                      <img className="img-fluid rounded-circle" src="img/authors/author-3.png" alt="..." width="50" />
                      <div className="ms-2">
                        <p className="text-sm mb-1 text-muted">Bid <span className="text-primary">0.005 BNB</span></p>
                        <p className="text-sm mb-0 text-muted">by <span className="text-primary">Mamie Barnett </span>at 6/15/2021, 3:20 AM</p>
                      </div>
                    </li>

                    
                    <li className="d-flex align-items-center rounded p-3 bd-3 bg-dark mb-2 card-hover-minimal">
                      <img className="img-fluid rounded-circle" src="img/authors/author-4.png" alt="..." width="50" />
                      <div className="ms-2">
                        <p className="text-sm mb-1 text-muted">Bid <span className="text-primary">0.005 BNB</span></p>
                        <p className="text-sm mb-0 text-muted">by <span className="text-primary">Nicholas Daniels </span>at 6/15/2021, 3:20 AM</p>
                      </div>
                    </li>

                    
                    <li className="d-flex align-items-center rounded p-3 bd-3 bg-dark mb-2 card-hover-minimal">
                      <img className="img-fluid rounded-circle" src="img/authors/author-5.png" alt="..." width="50" />
                      <div className="ms-2">
                        <p className="text-sm mb-1 text-muted">Bid <span className="text-primary">0.005 BNB</span></p>
                        <p className="text-sm mb-0 text-muted">by <span className="text-primary">Lori Hart </span>at 6/15/2021, 3:20 AM</p>
                      </div>
                    </li>

                  </div>
                </div>
              </div>

                
                <div className="col-lg-6">
                    <div className="row">
                        <div className="col-xl-8">
                            
                        </div>
                    </div>
                </div>

            </div>
        </div>
        </section>
        </div>
    )
}


export default SingleItem;